import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Tag, Spin } from 'antd';
import { EditOutlined, ArrowLeftOutlined, KeyOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useCompany } from '@/hooks/useCompanies';

const { Title } = Typography;

const CompanyDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: company, isLoading } = useCompany(id || '');

  if (isLoading) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }} />;
  }

  if (!company) {
    return <div>Empresa não encontrada</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/companies')} />
          <Title level={4} style={{ margin: 0 }}>Detalhes da Empresa</Title>
        </Space>
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => navigate(`/companies/${id}/edit`)}
          >
            Editar
          </Button>
          <Button
            icon={<KeyOutlined />}
            onClick={() => navigate(`/companies/${id}/token`)}
          >
            Gerenciar Token
          </Button>
        </Space>
      </div>

      <Card>
        <Descriptions bordered column={{ xs: 1, sm: 2, lg: 3 }}>
          <Descriptions.Item label="Nome">{company.name}</Descriptions.Item>
          <Descriptions.Item label="Nome Fantasia">{company.trade_name || '-'}</Descriptions.Item>
          <Descriptions.Item label="CNPJ">{company.cnpj}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={company.status === 'ACTIVE' ? 'green' : company.status === 'INACTIVE' ? 'red' : 'orange'}>
              {company.status === 'ACTIVE' ? 'Ativa' : company.status === 'INACTIVE' ? 'Inativa' : 'Suspensa'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="E-mail">{company.email}</Descriptions.Item>
          <Descriptions.Item label="Telefone">{company.phone || '-'}</Descriptions.Item>
          <Descriptions.Item label="Endereço" span={2}>{company.address || '-'}</Descriptions.Item>
          <Descriptions.Item label="Máx. Usuários">{company.max_users}</Descriptions.Item>
          <Descriptions.Item label="Máx. Dispositivos">{company.max_devices}</Descriptions.Item>
          <Descriptions.Item label="Usuários Ativos">{company.active_users_count}</Descriptions.Item>
          <Descriptions.Item label="Dispositivos Ativos">{company.active_devices_count}</Descriptions.Item>
          <Descriptions.Item label="Criado em">{company.created_at}</Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default CompanyDetail;
